import { Avatar, Badge } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import './members.css';
import { renderMouse } from '../../Socket';
import MyHeader from '../Header/Header.module.css';

const DocumentMembers = () => {
    const document = useSelector((state) => state.editor.documentInformation);
    const user = useSelector((state) => state.editor.userInformation);
    const [onlineUsers, setOnlineUsers] = useState([]);
    const colorOptions = useMemo(() => ['#f56a00', '#7265e6', '#ffbf00', '#87d068', '#ff6b81', '#00a2ae'], []);
    const [memberColors, setMemberColors] = useState({});

    const getInitials = (name) => {
        const names = name.split(" ");
        let initials = names[0].substring(0, 1).toUpperCase();
        if (names.length > 1) {
            initials += names[names.length - 1].substring(0, 1).toUpperCase();
        }
        return initials;
    };

    useEffect(() => {
        renderMouse(setOnlineUsers);
        // connectedClients(setConnectedSocketID);
    }, []);

    const getRandomColor = (memberId) => {
        if (memberColors[memberId]) {
            return memberColors[memberId];
        }
        let newColor;
        do {
            newColor = '#' + (Math.random() * 0xFFFFFF << 0).toString(16);
        } while (newColor === '#CF9FFF' || Object.values(memberColors).includes(newColor));
        setMemberColors((prevColors) => ({
            ...prevColors,
            [memberId]: newColor,
        }));
        return newColor;
    };

    // Filter out current user; show up to 4 avatars + count badge
    const collaborators = (document?.members || []).filter(m => m.id !== user.userId);
    const visibleCollaborators = collaborators.slice(0, 4);
    const extraCount = collaborators.length > 4 ? collaborators.length - 4 : 0;

    const totalWidth = visibleCollaborators.length > 0 
        ? 18 + ((visibleCollaborators.length - 1) * 12) + (extraCount > 0 ? 12 : 0)
        : 0;

    return (
        <div className={`member-avatar-container`} style={{ position: 'relative', width: totalWidth, height: 18 }}>
            <div style={{ 
                position: 'relative',
                width: '100%',
                height: '100%'
            }}>
                {visibleCollaborators.map((member, index) => (
                    <div 
                        key={member.id} 
                        style={{ 
                            position: 'absolute',
                            left: index * 12,
                            top: 0,
                            zIndex: visibleCollaborators.length - index
                        }}
                    >
                        <Badge
                            offset={[ -2, 16 ]}
                            style={{
                                width: 3,
                                height: 3,
                                backgroundColor: 'green',
                                padding: 0,
                                minWidth: 3
                            }}
                            dot={onlineUsers.some(onlineUser => onlineUser.userName === member.name)}
                        >
                            <Avatar
                                src={member.image}
                                style={{
                                    backgroundColor: member.image ? 'transparent' : getRandomColor(member.id),
                                    width: 18,
                                    height: 18,
                                    lineHeight: '18px',
                                    fontSize: 8,
                                    border: '2px solid #fff'
                                }}
                            >
                                {getInitials(member.name)}
                            </Avatar>
                        </Badge>
                    </div>
                ))}
                {extraCount > 0 && (
                    <div
                        title={`+${extraCount} more`}
                        style={{
                            position: 'absolute',
                            left: visibleCollaborators.length * 12,
                            top: 0,
                            width: 18,
                            height: 18,
                            borderRadius: '50%',
                            background: '#555',
                            color: '#fff',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: 7,
                            fontWeight: 500,
                            border: '2px solid #fff',
                            zIndex: 0
                        }}
                    >
                        +{extraCount}
                    </div>
                )}
            </div>
        </div>
    );
}

export default DocumentMembers;
